import { projectPhaseSearchType, projectSearchSortType, projectListItemTypes } from '@/Models';
import Resources from '@/Resources.js';
import Config from '@/Config.js';

export const projectExplorationCategoryKeys = {
    recommendations: 'recommendations',
    active: 'active',
    endingSoon: 'endingSoon',
    comingSoon: 'comingSoon',
    upcoming: 'upcoming',
    mostFunded: 'mostFunded',
    mostFundedCrowdfunding: 'mostFundedCrowdfunding',
    mostFundedLatePledge: 'mostFundedLatePledge',
    mostFundedAllTime: 'mostFundedAllTime',
    mostPopular: 'mostPopular',
    mostPopularUpcoming: 'mostPopularUpcoming',
    mostDiscussed: 'mostDiscussed',
    mostDiscussedUpcoming: 'mostDiscussedUpcoming',
    mostDiscussedCrowdfunding: 'mostDiscussedCrowdfunding',
    mostDiscussedLatePledge: 'mostDiscussedLatePledge',
    recentlyAddedUpdates: 'recentlyAddedUpdates',
    recentlyAddedUpdatesUpcoming: 'recentlyAddedUpdatesUpcoming',
    recentlyAddedUpdatesCrowdfunding: 'recentlyAddedUpdatesCrowdfunding',
    recentlyAddedUpdatesLatePledge: 'recentlyAddedUpdatesLatePledge',
    preorders: 'preorders',
    newestCrowdfunding: 'newestCrowdfunding',
    newestUpcoming: 'newestUpcoming',
    newestLatePledge: 'newestLatePledge',
    latePledge: 'latePledge',
    trending: 'trending',
};

export const projectExplorerSearchParamsValues = {
    [projectExplorationCategoryKeys.recommendations]: {},
    [projectExplorationCategoryKeys.active]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
            projectPhaseSearchType[projectPhaseSearchType.latePledge].name,
        ],
        includeRefs: false, // TODO: Remove in #20854
    },
    [projectExplorationCategoryKeys.endingSoon]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.endingSoon].name,
        includeRefs: false, // TODO: Remove in #20854
    },
    [projectExplorationCategoryKeys.crowdfunding]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
        ],
        includeRefs: false, // TODO: Remove in #20854
    },
    [projectExplorationCategoryKeys.mostFunded]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.latePledge].name,
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.mostFunded].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.mostFundedCrowdfunding]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.mostFunded].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.mostFundedLatePledge]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.latePledge].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.mostFunded].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.mostFundedAllTime]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
            projectPhaseSearchType[projectPhaseSearchType.latePledge].name,
            projectPhaseSearchType[projectPhaseSearchType.recentlyFunded].name,

        ],
        sortType: projectSearchSortType[projectSearchSortType.mostFunded].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.mostDiscussed]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.upcoming].name,
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
            projectPhaseSearchType[projectPhaseSearchType.latePledge].name,
            projectPhaseSearchType[projectPhaseSearchType.preorder].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.mostDiscussed].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.mostDiscussedUpcoming]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.upcoming].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.mostDiscussed].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.mostDiscussedCrowdfunding]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.mostDiscussed].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.mostDiscussedLatePledge]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.latePledge].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.mostDiscussed].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.recentlyAddedUpdates]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.upcoming].name,
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
            projectPhaseSearchType[projectPhaseSearchType.latePledge].name,
            projectPhaseSearchType[projectPhaseSearchType.preorder].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.recentUpdates].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.recentlyAddedUpdatesUpcoming]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.upcoming].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.recentUpdates].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.recentlyAddedUpdatesCrowdfunding]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.recentUpdates].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.recentlyAddedUpdatesLatePledge]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.latePledge].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.recentUpdates].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.preorders]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.preorder].name,
        ],
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.newestCrowdfunding]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.newest].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.newestUpcoming]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.upcoming].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.newest].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.mostPopularUpcoming]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.upcoming].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.mostPopular].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.trending]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.crowdfunding].name,
        ],
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.comingSoon]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.upcoming].name,
        ],
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.newestLatePledge]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.latePledge].name,
        ],
        sortType: projectSearchSortType[projectSearchSortType.newest].name,
        includeRefs: false,
    },
    [projectExplorationCategoryKeys.latePledge]: {
        projectPhaseSearchTypes: [
            projectPhaseSearchType[projectPhaseSearchType.latePledge].name,
        ],
        includeRefs: false,
    },
};

export const buildExploreProjectCategories = (isAuthenticated = false) => [
    {
        label: isAuthenticated
            ? Resources.Homepage.ExploreCategoryForYou
            : Resources.Homepage.ExploreCategoryYouMayLike,
        key: projectExplorationCategoryKeys.recommendations,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.recommendations],
        actionLabel: Resources.Homepage.ExploreCategoryActionLabelGeneral,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.recommendations]),
    },
    {
        label: Resources.Homepage.ExploreCategoryActive,
        key: projectExplorationCategoryKeys.active,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.active],
        actionLabel: Resources.Homepage.ExploreCategoryActionLabelActive,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.active]),
    },
    {
        label: Resources.Homepage.ExploreCategoryEndingSoon,
        key: projectExplorationCategoryKeys.endingSoon,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.endingSoon],
        actionLabel: Resources.Homepage.ExploreCategoryActionLabelEndingSoon,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.endingSoon]),
    },
];

const buildCrowdfundingProjectCategories = () => [
    {
        label: Resources.Homepage.ProjectListTrendingCategoryTitle,
        key: projectExplorationCategoryKeys.trending,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.trending],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.trending]),
    },
    {
        label: Resources.Homepage.ProjectListNewCategoryTitle,
        key: projectExplorationCategoryKeys.newestCrowdfunding,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.newestCrowdfunding],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.newestCrowdfunding]),
    },
    {
        label: Resources.Homepage.ProjectListMostFundedCategoryTitle,
        key: projectExplorationCategoryKeys.mostFundedCrowdfunding,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostFundedCrowdfunding],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostFundedCrowdfunding]),
    },
];

const buildUpcomingProjectCategories = () => [
    {
        label: Resources.Homepage.ProjectListComingSoonCategoryTitle,
        key: projectExplorationCategoryKeys.comingSoon,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.comingSoon],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.comingSoon]),
    },
    {
        label: Resources.Homepage.ProjectListNewCategoryTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.newestUpcoming],
        key: projectExplorationCategoryKeys.newestUpcoming,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.newestUpcoming]),
    },
    {
        label: Resources.Homepage.ProjectListMostPopularCategoryTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostPopularUpcoming],
        key: projectExplorationCategoryKeys.mostPopularUpcoming,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostPopularUpcoming]),
    },
];

export const buildNewestProjectCategories = () => [
    {
        label: Resources.Homepage.UpcomingSectionTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.newestUpcoming],
        key: projectExplorationCategoryKeys.newestUpcoming,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.newestUpcoming]),
    },
    {
        label: Resources.Homepage.CrowdfundingProjectsSectionTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.newestCrowdfunding],
        key: projectExplorationCategoryKeys.newestCrowdfunding,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.newestCrowdfunding]),
    },
    {
        label: Resources.Homepage.LatePledgeProjectsSectionTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.newestLatePledge],
        key: projectExplorationCategoryKeys.newestLatePledge,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.newestLatePledge]),
    },
];

export const buildLatePledgeProjectCategories = () => [
    {
        label: Resources.Homepage.ProjectListNewCategoryTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.latePledge],
        key: projectExplorationCategoryKeys.latePledge,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.latePledge]),
    },
    {
        label: Resources.Homepage.ProjectListMostFundedCategoryTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostFundedLatePledge],
        key: projectExplorationCategoryKeys.mostFundedLatePledge,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostFundedLatePledge]),
    },
];

export const buildMostDiscussedProjectCategories = () => [
    {
        label: Resources.Homepage.ProjectListAllCategoryTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostDiscussed],
        key: projectExplorationCategoryKeys.mostDiscussed,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostDiscussed]),
    },
    {
        label: Resources.Homepage.UpcomingSectionTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostDiscussedUpcoming],
        key: projectExplorationCategoryKeys.mostDiscussedUpcoming,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostDiscussedUpcoming]),
    },
    {
        label: Resources.Homepage.CrowdfundingProjectsSectionTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostDiscussedCrowdfunding],
        key: projectExplorationCategoryKeys.mostDiscussedCrowdfunding,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostDiscussedCrowdfunding]),
    },
    {
        label: Resources.Homepage.LatePledgeProjectsSectionTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostDiscussedLatePledge],
        key: projectExplorationCategoryKeys.mostDiscussedLatePledge,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostDiscussedLatePledge]),
    },
];

export const buildRecentlyAddedUpdatesProjectCategories = () => [
    {
        label: Resources.Homepage.ProjectListAllCategoryTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.recentlyAddedUpdates],
        key: projectExplorationCategoryKeys.recentlyAddedUpdates,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.recentlyAddedUpdates]),
    },
    {
        label: Resources.Homepage.UpcomingSectionTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.recentlyAddedUpdatesUpcoming],
        key: projectExplorationCategoryKeys.recentlyAddedUpdatesUpcoming,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.recentlyAddedUpdatesUpcoming]),
    },
    {
        label: Resources.Homepage.CrowdfundingProjectsSectionTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.recentlyAddedUpdatesCrowdfunding],
        key: projectExplorationCategoryKeys.recentlyAddedUpdatesCrowdfunding,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.recentlyAddedUpdatesCrowdfunding]),
    },
    {
        label: Resources.Homepage.LatePledgeProjectsSectionTitle,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.recentlyAddedUpdatesLatePledge],
        key: projectExplorationCategoryKeys.recentlyAddedUpdatesLatePledge,
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.recentlyAddedUpdatesLatePledge]),
    },
];

export const buildHighestFundedProjectCategories = () => [
    {
        // We need to add only active projects.
        label: Resources.Homepage.ExploreCategoryActive,
        key: projectExplorationCategoryKeys.mostFunded,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostFunded],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostFunded]),
    },
    {
        label: Resources.Homepage.ProjectListAllTimeCategoryTitle,
        key: projectExplorationCategoryKeys.mostFundedAllTime,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostFundedAllTime],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.mostFundedAllTime]),
    },
];

export const buildPreordersProjectCategories = () => [
    {
        label: Resources.Homepage.PreordersSectionTitle,
        key: projectExplorationCategoryKeys.preorders,
        searchParams: projectExplorerSearchParamsValues[projectExplorationCategoryKeys.preorders],
        url: buildExploreUrlParams(projectExplorerSearchParamsValues[projectExplorationCategoryKeys.preorders]),
    },
];
export function buildExploreUrlParams(searchParams) {
    const params = removeIncludeRefsProp(searchParams); // TODO: Remove in #20854

    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => query.set(k, v));

    return `${Config.navigation.searchUrl}/?${query}`;
}

export function buildProjectExplorerModel(label, key, searchParams, actionLabel) {
    const params = removeIncludeRefsProp(searchParams); // TODO: Remove in #20854

    return [{
        label,
        key,
        searchParams,
        actionLabel,
        url: buildExploreUrlParams(params),
    }];
}

export const homeProjectListsCategoryKeys = {
    [projectListItemTypes.storesAndPreorders]: 'storesAndPreorders',
    [projectListItemTypes.upcoming]: 'upcoming',
    [projectListItemTypes.crowdfunding]: 'crowdfunding',
    [projectListItemTypes.latePledge]: 'latePledge',
    [projectListItemTypes.soloMode]: 'soloMode',
    [projectListItemTypes.stretchPay]: 'stretchPay',
    [projectListItemTypes.ttrpg]: 'ttrpg',
};
// TODO: Remove in #20854
function removeIncludeRefsProp(searchParams) {
    const params = { ...searchParams };
    delete params.includeRefs;
    return params;
}

export function buildProjectsExploreListModel() {
    return [
        {
            title: Resources.Homepage.ExploreSectionTitle,
            icon: 'magnifying-glass',
            sectionKey: 'explore',
            items: buildExploreProjectCategories(),
            defaultCategoryKey: projectExplorationCategoryKeys.recommendations,
        },
        {
            title: Resources.Homepage.CrowdfundingProjectsSectionTitle,
            icon: 'rocket',
            sectionKey: 'crowdfunding',
            items: buildCrowdfundingProjectCategories(),
            defaultCategoryKey: projectExplorationCategoryKeys.trending,

        },
        {
            title: Resources.Homepage.UpcomingSectionTitle,
            icon: 'clock',
            sectionKey: 'upcoming',
            items: buildUpcomingProjectCategories(),
            defaultCategoryKey: projectExplorationCategoryKeys.comingSoon,
        },
        {
            title: Resources.Homepage.NewOnThePlatformSectionTitle,
            sectionKey: 'newestProjects',
            items: buildNewestProjectCategories(),
            defaultCategoryKey: projectExplorationCategoryKeys.newestUpcoming,
        },
        {
            title: Resources.Homepage.LatePledgeProjectsSectionTitle,
            icon: 'shopping-bag',
            sectionKey: 'latePledge',
            items: buildLatePledgeProjectCategories(),
            defaultCategoryKey: projectExplorationCategoryKeys.latePledge,
        },
        {
            title: Resources.Homepage.MostDiscussedSectionTitle,
            sectionKey: 'mostDiscussed',
            items: buildMostDiscussedProjectCategories(),
            defaultCategoryKey: projectExplorationCategoryKeys.mostDiscussed,
        },
        {
            title: Resources.Homepage.RecentlyAddedUpdatesSectionTitle,
            sectionKey: 'recentlyAddedUpdates',
            items: buildRecentlyAddedUpdatesProjectCategories(),
            defaultCategoryKey: projectExplorationCategoryKeys.recentlyAddedUpdates,
        },
        {
            title: Resources.Homepage.MostFundedSectionTitle,
            sectionKey: 'highestFunded',
            items: buildHighestFundedProjectCategories(),
            defaultCategoryKey: projectExplorationCategoryKeys.mostFunded,
        },
        {
            title: Resources.Homepage.PreordersSectionTitle,
            sectionKey: 'preorders',
            items: buildPreordersProjectCategories(),
            defaultCategoryKey: projectExplorationCategoryKeys.preorders,
        },
    ];
}
